export const FEATURE_TYPES = {
    BLEND_DATA: 'blendDataSettings',
    WIDGET_METRIC: 'widgetMetric',
    CUSTOM_METRIC: 'customMetric',
    DATASTREAM: 'datastream',
    METRIC_SETTINGS: 'metricSettings',
    FILTERS: 'filters',
};
